// extracted by mini-css-extract-plugin
export default {"news":"News_news__kX+ZC","newsCardsContainer":"News_newsCardsContainer__R7MT-","button":"News_button__HFiwO"};